let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7BdRT")).then(() => parcelRequire('cLAxe'));